// ink-component
import React, { HTMLAttributes, ReactNode } from 'react';
import styled from 'styled-components';
import getGlobalProps from '../../../helpers/constants/global-props';

export interface TagContainerProps extends HTMLAttributes<HTMLDivElement> {
  /** Tags located inside the Tag.Container  */
  children?: ReactNode;
}

const TagContainerWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

const globalProps = getGlobalProps({});

/**
 * @purpose Wrapper for tags for the correct spacing
 * @group Tag
 * @HTMLType HTMLDivElement
 */
function TagContainer(props: TagContainerProps) {
  const buttonProps = {
    ...props,
    ...globalProps,
    'data-testid': props['data-testid'],
    style: undefined,
    className: undefined,
  };

  return <TagContainerWrapper {...buttonProps} />;
}

TagContainer.defaultProps = {
  children: undefined,
};

TagContainer.displayName = 'Tag.Container';

export default TagContainer;
